export default require('../table/Boolean').default.concat();


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/form/Boolean.js
// module id = 274
// module chunks = 0